import {doppeActionTypeDefineViewerMetadata} from "../../client-server-common/doppe-action-types/doppe-action-type";
import React from "react";
import {doppeActionTypeHoppBlogPosts} from "./doppe-action-type-hopp-blog-posts";

export const doppeActionTypeHoppBlogPostsViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeHoppBlogPosts, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeHoppBlogPostsWidget: (await import(
                './doppe-action-type-hopp-blog-posts-widget'
                )).DoppeActionTypeHoppBlogPostsWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeHoppBlogPostsWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeHoppBlogPostsWidget
                props={renderProps}
            />
        );
    }
}) 